import { Decoration, EditorView } from "@codemirror/view";
import { StateEffect, StateField } from "@codemirror/state";
import nspell from "nspell";

let dictionary;
let ukDictionary;


let spellCheckSettings = {
  enabled: false,
  us: true,
  uk: true
};
(async () => {
  const [usAff, usDic, ukAff, ukDic] = await Promise.all([
    fetch("/dictionaries/en_US.aff").then((response) => response.text()),
    fetch("/dictionaries/en_US.dic").then((response) => response.text()),
    fetch("/dictionaries/en-GB.aff").then((response) => response.text()),
    fetch("/dictionaries/en-GB.dic").then((response) => response.text())
  ]);
  
  dictionary = nspell(usAff, usDic);
  ukDictionary = nspell(ukAff, ukDic);
})();

const isLatexContent = (text) => {
  const latexPatterns = [
    /\\[a-zA-Z]+\{[^}]*\}/,
    /\$[^$]*\$/,
    /\$\$[^$]*\$\$/,
    /\\begin\{[^}]*\}/,
    /\\end\{[^}]*\}/,
    /\\[a-zA-Z]+(?:\[[^\]]*\])?\{[^}]*\}/,
    /%.+$/,
  ];
  return latexPatterns.some((pattern) => pattern.test(text));
};

const spellCheckField = StateField.define({
  create() {
    return Decoration.none;
  },
  update(decorations, transaction) {
    const builder = [];
    const text = transaction.state.doc.toString();
    const wordRegex = /(?<!\\|\{|\[|%)\b[a-zA-Z]{3,}\b(?!\}|\]|\$)/g;
    
    let match;
    while ((match = wordRegex.exec(text)) !== null) {
      const word = match[0];
      const context = text.slice(
        Math.max(0, match.index - 20),
        match.index + word.length + 20
      );

      const isCorrect = (spellCheckSettings.us && dictionary?.correct(word)) || 
                       (spellCheckSettings.uk && ukDictionary?.correct(word));
      if (!spellCheckSettings.enabled) {
          return Decoration.none;
      }
      if (!isLatexContent(context) && !isCorrect) {
        builder.push(
          Decoration.mark({
            class: "cm-spelling-error",
            attributes: {
              "data-word": word,
              title: `Possible spelling error: ${word}`
            },
            contextMenu: true
          }).range(match.index, match.index + word.length)
        );
      }
    }
    return Decoration.set(builder, true);
  },
  provide: field => EditorView.decorations.from(field)
});
// function showSpellCheckSettings(event) {
//   const settingsMenu = document.createElement('div');
//   settingsMenu.className = 'spell-check-settings-menu';
//   settingsMenu.style.position = 'fixed';
//   settingsMenu.style.left = `${event.clientX}px`;
//   settingsMenu.style.top = `${event.clientY}px`;

//   // Create a styled header section
//   const header = document.createElement('div');
//   header.className = 'settings-header';
//   header.innerHTML = `
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
//       <path d="M12 20l9-9-9-9-9 9 9 9z"/>
//       <path d="M16 8l-4 4-4-4"/>
//     </svg>
//     <span>Spell Check Settings</span>
//   `;
//   settingsMenu.appendChild(header);

//   // Create a content container
//   const content = document.createElement('div');
//   content.className = 'settings-content';
//   settingsMenu.appendChild(content);

//   const createCheckbox = (label, key) => {
//     const container = document.createElement('div');
//     container.className = 'settings-checkbox-container';
    
//     const checkbox = document.createElement('input');
//     checkbox.type = 'checkbox';
//     checkbox.id = `spell-check-${key}`;
//     checkbox.className = 'custom-checkbox';
//     checkbox.checked = spellCheckSettings[key];
//     checkbox.onchange = () => {
//       spellCheckSettings[key] = checkbox.checked;
//       updateSpellCheckSettings(spellCheckSettings);
//     };
    
//     const labelElement = document.createElement('label');
//     labelElement.textContent = label;
//     labelElement.htmlFor = `spell-check-${key}`;
    
//     container.appendChild(checkbox);
//     container.appendChild(labelElement);
//     return container;
//   };

//   content.appendChild(createCheckbox('US English', 'us'));
//   content.appendChild(createCheckbox('UK English', 'uk'));

//   document.body.appendChild(settingsMenu);
// }

function showSpellCheckSettings(event) {
  const settingsMenu = document.createElement('div');
  settingsMenu.className = 'spell-check-settings-menu';
  
  // Add toggle switch
  const toggleContainer = document.createElement('div');
  toggleContainer.className = 'settings-toggle-container';
  
  const toggle = document.createElement('input');
  toggle.type = 'checkbox';
  toggle.id = 'spell-check-toggle';
  toggle.checked = spellCheckSettings.enabled;
  toggle.onchange = () => {
    spellCheckSettings.enabled = toggle.checked;
    // Show/hide language options
    languageOptions.style.display = toggle.checked ? 'block' : 'none';
    // Trigger re-check
    document.dispatchEvent(new CustomEvent('spellCheckSettingsChanged', {
      detail: spellCheckSettings
    }));
  };

  const toggleLabel = document.createElement('label');
  toggleLabel.htmlFor = 'spell-check-toggle';
  toggleLabel.textContent = 'Enable Spell Check';
  
  toggleContainer.appendChild(toggle);
  toggleContainer.appendChild(toggleLabel);
  settingsMenu.appendChild(toggleContainer);

  // Language options container
  const languageOptions = document.createElement('div');
  languageOptions.className = 'language-options';
  languageOptions.style.display = spellCheckSettings.enabled ? 'block' : 'none';

  // // Add US/UK options using existing createCheckbox function
  // languageOptions.appendChild(createCheckbox('US English', 'us'));
  // languageOptions.appendChild(createCheckbox('UK English', 'uk'));

  settingsMenu.appendChild(languageOptions);
  document.body.appendChild(settingsMenu);
}


// function updateSpellCheckSettings(settings) {
//   spellCheckSettings = { ...settings };
//   // Trigger a re-check of the document
//   EditorView.updateListener.of((update) => {
//     update.view.dispatch({
//       effects: StateEffect.appendConfig.of(spellCheckField)
//     });
//   });
// }

const handleContextMenuSpellCheck = EditorView.domEventHandlers({
  contextmenu: (event, view) => {
    // Get readOnly state from props/context
    const readOnly = view.state.readOnly;
    const pos = view.posAtCoords({ x: event.clientX, y: event.clientY });
    if (pos === null) return;
    
    const decorations = view.state.field(spellCheckField);
    let found = false;
    let foundWord = null;
    let wordStart = null;
    let wordEnd = null;
    
    decorations.between(pos, pos, (from, to, decoration) => {
      found = true;
      foundWord = decoration.spec.attributes["data-word"];
      wordStart = from;
      wordEnd = to;
    });

    if (found && foundWord) {
      // Select the entire word
      view.dispatch({
        selection: {anchor: wordStart, head: wordEnd}
      });
      
      event.preventDefault();

      // If readOnly, only show the misspelled word indicator
      if (readOnly) {
        // Optional: Show a tooltip or some visual indication
        return;
      }

      // Otherwise show suggestions menu for editing
      showSuggestions(event, view, foundWord, wordStart, wordEnd);
    }
  }
});


function showSuggestions(event, view, word, from, to) {
  const menu = document.createElement('div');
  menu.className = 'spelling-suggestions-menu';
  menu.style.position = 'fixed';
  menu.style.left = `${event.clientX}px`;
  menu.style.top = `${event.clientY + 10}px`;

  let suggestions = new Set();
  if (spellCheckSettings.us) {
    dictionary.suggest(word).forEach(s => suggestions.add(s));
  }
  if (spellCheckSettings.uk) {
    ukDictionary.suggest(word).forEach(s => suggestions.add(s));
  }

  Array.from(suggestions).slice(0, 5).forEach(suggestion => {
    const item = document.createElement('div');
    item.className = 'suggestion-item';
    item.textContent = suggestion;
    item.onclick = () => {
      replaceMisspelledWord(view, from, to, suggestion);
      closeMenu();
    };
    menu.appendChild(item);
  });

  const settingsItem = document.createElement('div');
  settingsItem.className = 'suggestion-item settings-item';
  settingsItem.textContent = 'Spell Check Settings';
  settingsItem.onclick = () => {
    document.dispatchEvent(new CustomEvent('openSpellCheckSettings', {
      detail: { openSettings: true }
    }));
    closeMenu();
  };
  menu.appendChild(settingsItem);

  document.body.appendChild(menu);

  // 🚀 Add event listener to close menu when clicking outside
  function handleClickOutside(event) {
    if (!menu.contains(event.target)) {
      closeMenu();
    }
  }

  function closeMenu() {
    document.body.removeChild(menu);
    document.removeEventListener('click', handleClickOutside);
  }

  // Attach event listener after a slight delay to prevent immediate closing
  setTimeout(() => {
    document.addEventListener('click', handleClickOutside);
  }, 10);
}



document.addEventListener('spellCheckSettingsChanged', (event) => {
  spellCheckSettings = event.detail;
  // Force a re-check of the document
  EditorView.updateListener.of((update) => {
    update.view.dispatch({
      effects: StateEffect.appendConfig.of(spellCheckField)
    });
  });
});

function replaceMisspelledWord(view, from, to, suggestion) {
  view.dispatch({
    changes: { from, to, insert: suggestion }
  });
}

const spellChecker = [
  spellCheckField,
  handleContextMenuSpellCheck,
  EditorView.updateListener.of((update) => {
    if (update.docChanged) {
      update.view.dispatch({
        effects: StateEffect.appendConfig.of(spellCheckField),
      });
    }
  }),
];

const spellCheckTheme = EditorView.baseTheme({
  ".cm-spelling-error": {
    textDecoration: "underline dotted red",
    textDecorationSkipInk: "none",
    textDecorationThickness: "2px",
  },
  // ".spelling-suggestions-menu": {
  //   background: "white",
  //   border: "1px solid #ccc",
  //   borderRadius: "4px",
  //   boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
  //   padding: "4px 0",
  //   zIndex: 1000,
  //   minWidth: "150px"
  // },
  // ".suggestion-item": {
  //   padding: "6px 12px",
  //   cursor: "pointer",
  //   "&:hover": {
  //     backgroundColor: "#f0f0f0"
  //   }
  // },
  ".add-dictionary": {
    borderTop: "1px solid #eee",
    marginTop: "4px",
    fontWeight: "500"
  },
  // ".settings-item": {
  //   borderTop: "1px solid #eee",
  //   marginTop: "4px",
  //   fontWeight: "500"
  // },
  ".spell-check-settings-menu": {
    background: "var(--background-primary, #ffffff)",
    border: "1px solid var(--border-color, #e0e0e0)",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    padding: "16px",
    zIndex: 1000,
    minWidth: "250px",
    color: "var(--text-primary, #333333)",
    fontSize: "14px",
  },
  
  ".settings-checkbox-container": {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 0",
    transition: "background-color 0.2s ease",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      background: "var(--background-hover, #f5f5f5)"
    }
  },
  
  ".settings-checkbox-container input[type='checkbox']": {
    width: "18px",
    height: "18px",
    cursor: "pointer",
    accentColor: "var(--primary-color, #4a90e2)"
  },
  
  ".settings-checkbox-container label": {
    cursor: "pointer",
    userSelect: "none",
    flex: 1,
    fontWeight: "500"
  },
  
 ".spelling-suggestions-menu": {
    background: "#ffffff",
    border: "1px solid #e1e4e8",
    borderRadius: "6px",
    boxShadow: "0 8px 24px rgba(149, 157, 165, 0.2)",
    padding: "8px 0",
    zIndex: 1000,
    minWidth: "200px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
  },

  ".suggestion-item": {
    padding: "6px 16px",
    fontSize: "14px",
    color: "#24292e",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f6f8fa"
    }
  },
  
  ".settings-item": {
    borderTop: "1px solid var(--border-color, #e0e0e0)",
    marginTop: "8px",
    paddingTop: "8px",
    fontWeight: "600",
    color: "var(--text-secondary, #666666)"
  },
  '.settings-toggle-container': {
    padding: '8px 0',
    borderBottom: '1px solid var(--border-color, #e0e0e0)',
    marginBottom: '8px'
  },
  
  '.language-options': {
    transition: 'opacity 0.2s ease'
  }
});

export { spellChecker as default, spellCheckTheme, spellCheckField };
export const spellCheckSettingsOptions = [
  // { label: 'Both US and UK', value: 'both' },
  { label: 'US English', value: 'us' },
  { label: 'UK English', value: 'uk' }
];